<template>
  <button :data-status="currentStatus" @click="handleClick">{{ buttonText }}</button>
</template>
<script>
import { HTTPMethod } from '@padlet/fetch'
import { __ } from 'bits/intl'
import { captureException } from 'bits/error_tracker'
import { fetchJson } from 'surface/api_fetch'

export default {
  props: {
    status: {
      default: 'following',
    },
    targetUserId: Number,
  },
  data: function () {
    // only mutate currentStatus, don't mutate props coming from parent
    return {
      currentStatus: this.status,
    }
  },
  computed: {
    buttonText: function () {
      if (this.currentStatus === 'following') {
        return __('Following')
      } else {
        return __('Follow')
      }
    },
  },
  methods: {
    async follow() {
      try {
        await fetchJson('/api/user_follows.json', {
          method: HTTPMethod.post,
          jsonData: {
            user_id: this.targetUserId,
          },
        })
        this.currentStatus = 'following'
      } catch (e) {
        captureException(e)
        alert(__('Oops! Something went wrong. Please try again.'))
      }
    },
    async unfollow() {
      try {
        await fetchJson('/api/user_follows.json', {
          method: HTTPMethod.delete,
          jsonData: {
            user_id: this.targetUserId,
          },
        })
        this.currentStatus = 'notfollowing'
      } catch (e) {
        captureException(e)
        alert(__('Oops! Something went wrong. Please try again.'))
      }
    },
    handleClick: function () {
      if (this.currentStatus === 'following') {
        this.unfollow()
      } else {
        this.follow()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';

button[data-status='following'] {
  @include inverse-button-color($green-color);
}
</style>
